import { useClientI18nModelStore } from '@/models/client-i18n/clientI18n';
import usePersistFn from 'ahooks/lib/usePersistFn';
import type { FormItemProps, InputProps, InputRef } from 'aui';
import { Button, Form, Input, Spin } from 'aui';
import type { FC } from 'react';
import { useRef, useState } from 'react';
import CountDownButton from './CountDownButton';

const CaptchaFormItem: FC<{
  sendTxt: string;
  inputProps?: InputProps;
  formItemProps?: FormItemProps;
  onStart?: () => Promise<boolean>;
  onFinish?: () => void;
  loading?: boolean;
  showCountDownButton?: boolean;
  autoFocusAfterOnStart?: boolean;
}> = ({
  sendTxt,
  inputProps,
  formItemProps,
  onStart,
  onFinish,
  loading,
  showCountDownButton = true,
  autoFocusAfterOnStart = true,
}) => {
  const clientI18n = useClientI18nModelStore((x) => x.clientI18n);

  const [showCountdown, setShowCountdown] = useState(false);

  const inputRef = useRef<InputRef>(null);

  const triggerStart = usePersistFn(async () => {
    let canStart = false;
    if (onStart) {
      canStart = await onStart();
      if (autoFocusAfterOnStart) {
        inputRef.current?.focus();
      }
    }
    if (canStart) {
      setShowCountdown(true);
    }
  });

  return (
    <Form.Item
      name="code"
      style={{ marginBottom: 16 }}
      rules={[
        {
          required: true,
          message: clientI18n('user.loginOrRegister.rule.required.captcha'),
        },
      ]}
      {...formItemProps}
    >
      <Input
        ref={inputRef}
        size="large"
        allowClear
        placeholder={clientI18n('user.loginOrRegister.captcha.placeholder')}
        addonAfter={
          // eslint-disable-next-line no-nested-ternary
          loading ? (
            <Spin spinning size="small" />
          ) : showCountDownButton ? (
            <CountDownButton
              type="link"
              className="flex items-center justify-center p-0"
              showCountdown={showCountdown}
              onFinish={() => {
                setShowCountdown(false);
                onFinish?.();
              }}
              onClick={async () => {
                triggerStart();
              }}
            >
              {sendTxt}
            </CountDownButton>
          ) : (
            <Button
              type="link"
              className="flex items-center justify-center p-0"
              onClick={async () => {
                triggerStart();
              }}
            >
              {sendTxt}
            </Button>
          )
        }
        {...inputProps}
      />
    </Form.Item>
  );
};

export default CaptchaFormItem;
